import React from 'react';
import { Link } from 'react-router-dom';
import ServicesSection from '../components/ServicesSection';
import Cart from '../components/Cart';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './PublicPage.css';

const PublicPage = () => {
  return (
    <div className="public-page">
      <div className="public-container">
        <Header rightContent={
          <Link to="/auth" className="header-signin-btn">Sign In / Sign Up</Link>
        } />

        <main className="public-content">
          {/* <div className="public-card">
            <div className="public-icon">👋</div>
            <h2>Welcome to MYHELPZ</h2>
            <p className="public-text">
              You are currently viewing the public access page. To access all features,
              please authenticate with your phone number.
            </p>
            
            <div className="public-features">
              <h3>What you can do:</h3>
              <ul>
                <li>Browse public information</li>
                <li>View service listings</li>
                <li>Learn about our services</li>
              </ul>
            </div>

          </div> */}

          <div className="info-section">            
            <p className="info-text">
              Life gets easier with MyHelpz. Book a verified and reliable Assistant for everyday help, whenever you need it.
            </p>
          </div>

          <ServicesSection />
        </main>
      </div>
      <Cart />
      <Footer />
    </div>
  );
};

export default PublicPage;

